module.exports = __webpack_public_path__ + "static/WEDDING E&M-43-0b943e61d81403d142ba6fbcd14b7cc5.jpg";